import { render, staticRenderFns } from "./KabupatenList.vue?vue&type=template&id=ab6d2346"
import script from "./KabupatenList.vue?vue&type=script&lang=js"
export * from "./KabupatenList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports